var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymptoms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 76,
    viewBox: "0 0 70 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3434 15.9719C51.3434 24.7929 43.9372 31.9438 34.8011 31.9438C25.665 31.9438 18.2588 24.7929 18.2588 15.9719C18.2588 7.15086 25.665 0 34.8011 0C43.9372 0 51.3434 7.15086 51.3434 15.9719Z",
    fill: "#5FBDD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0675 43.1682C12.7374 52.1089 9.59239 68.7794 9.12988 75.2986H60.4681C60.4681 75.2986 60.4681 55.741 54.918 43.1682C49.368 30.5955 42.4304 31.9925 35.4928 31.9925C28.5552 31.9925 20.23 31.9925 16.0675 43.1682Z",
    fill: "#5FBDD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9346 48.4844C39.9346 51.3197 37.6361 53.6182 34.8008 53.6182C31.9655 53.6182 29.667 51.3197 29.667 48.4844C29.667 45.6491 31.9655 43.3506 34.8008 43.3506C37.6361 43.3506 39.9346 45.6491 39.9346 48.4844Z",
    fill: "#CFE8EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5068 47.9153C36.5068 47.2852 37.2699 46.7744 38.2112 46.7744H67.8871C68.8284 46.7744 69.5915 47.2852 69.5915 47.9153C69.5915 48.5453 68.8284 49.0561 67.8871 49.0561H38.2112C37.2699 49.0561 36.5068 48.5453 36.5068 47.9153Z",
    fill: "#CFE8EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63C30 60.2386 32.2386 58 35 58C37.7614 58 40 60.2386 40 63C40 65.7614 37.7614 68 35 68C32.2386 68 30 65.7614 30 63Z",
    fill: "#CFE8EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5068 63.3161C36.5068 64.2612 35.735 65.0273 34.7829 65.0273H1.72359C0.771484 65.0273 -0.000354767 64.2612 -0.000354767 63.3161C-0.000354767 62.371 0.771484 61.6048 1.72359 61.6048H34.7829C35.735 61.6048 36.5068 62.371 36.5068 63.3161Z",
    fill: "#CFE8EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptoms);
export default __webpack_public_path__ + "static/media/symptoms.06ee8d641454fcd8f1babc128dd88bcc.svg";
export { ForwardRef as ReactComponent };